var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"d-flex",attrs:{"to":{ name: 'learning-unit' },"rel":"noopener noreferrer"}},[_c('img',{staticClass:"d-inline-block my-auto mr-3",attrs:{"src":require("@/assets/4life-logo.svg"),"height":_vm.size}})])}
var staticRenderFns = []

export { render, staticRenderFns }